import React, { useCallback } from 'react'
import { useStyles } from './styles'
import { exportToCsv } from 'src/utils'
import { CustomTable, Loading } from 'src/components'
import { useGetGeneticEvaluationList } from 'src/hooks/api/genetic-evaluation'
import { IAnimal } from 'src/dto/animal.dto'
import { GeneticEvaluationHeader } from './GeneticEvaluationHeader'

interface IGeneticEvaluation {
  data?: IAnimal
}

const tableHeader = [
  {
    property: 'idDeps',
    name: 'DEP',
    format: (value: string | null) => (value ? value : '-'),
    textAlign: 'center'
  },

  {
    property: 'acuracia',
    name: 'AC',
    textAlign: 'center',
    format: (value: string | null) => (value ? value : '-')
  },
  {
    property: 'valor',
    name: 'PORCENTAGEM%',
    textAlign: 'center',
    format: (value: string | null) => (value ? value : '-')
  }
]

export const GeneticEvaluation: React.FC<IGeneticEvaluation> = ({ data }) => {
  const styles = useStyles()
  const { data: geneticEvaluationList, isLoading, refetch, isError, isRefetching } = useGetGeneticEvaluationList()

  const isLoadingData = isLoading || isRefetching

  const animalGeneticEvaluationList = geneticEvaluationList?.filter((item) => item.idAnimal === data?.idAnimal)

  const exportData = useCallback(() => {
    if (!data) return

    const columns = {
      idDeps: 'DEP',
      acuracia: 'AC',
      valor: 'PORCENTAGEM%'
    }

    const fileName = `Avaliação Genética Animal:${data?.idAnimal}`
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_')

    exportToCsv(animalGeneticEvaluationList!, columns, fileName)
  }, [data, animalGeneticEvaluationList])

  return (
    <section>
      <GeneticEvaluationHeader
        onExport={handleExport}
        disabled={isLoadingData || !animalGeneticEvaluationList?.length}
      />

      <div className={styles.geneticEvaluationContent}>
        {isLoadingData || isError ? (
          <Loading isError={isError} refetch={refetch} />
        ) : (
          <CustomTable header={tableHeader} body={animalGeneticEvaluationList!} exportData={exportData} />
        )}
      </div>
    </section>
  )
}

const handleExport = () => {
  const event = new CustomEvent('exportData')
  window.dispatchEvent(event)
}
